export default {
	COPYRIGHT:
`  /\\ \\                   
 / /\\ \\   Build by:      
/ /__\\ \\  toinekamps.com 
\\/____\\/                 `
};

// for bezier tweens
export const EASINGS = {
	EASE_IN: '0.4,0,0.68,0.06',
	EASE_IN_OUT: '0.66,0,0.34,1',
	EASE_OUT: '0.4,1,0.68,1',
	EASE_OUT_LONG: '0,0.85,0.25,1',
	EASE_IN_SHORT_OUT: '0.15,0,0.15,1',
	EASE_IN_OUT_ELASTIC: '0.75,-0.5,0,1.25'
};